export default __webpack_public_path__ + "static/media/10.e0b25eb4.jpg";